import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { CommonService } from "../../../shared/common.service";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { EventEmitter } from "events";
import { debounceTime, distinctUntilChanged, startWith } from "rxjs/operators";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { StreamService } from "../../../shared/stream.service";
import { HomeService } from "../../../main/home.service";
import { DashboardService } from "../../../main/dashboard/dashboard.service";
import { CircleService } from "../../../main/circles/circle.service";
import { interval, Subscription } from "rxjs";
import { ChatService } from "../../../main/circles/chat.service";
import { CircleChatService } from "../../../main/circles/circle-chat/circle-chat.service";
import * as moment from "moment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @Input() messageCount = 0;
  searchField: any;
  dropdownForm: FormGroup;
  suggestionList: [];
  userDetail: any;
  projectConfigList = [];
  showSearch: boolean = true;
  showEditProfile:any;
  showChangePassword: any;
  showAdminPanel: any;
  showSignOut: any;
  departmentList = [];
  divisionList = [];
  // applied header filter
  selectedDivision: string = null;
  selectedDepartments: string[] = [];
  // draft values while the filter panel is open, applied on "Done"
  showFilterPanel: boolean = false;
  draftDivision: string = null;
  draftDepartments: string[] = [];
  departmentSearchText: string = "";
  showTuftsDropdowm:boolean = true
  showPlexomeHeader:boolean = true
  chatPanel:boolean = false
  chatSearchText: string = "";
  chatConfigObs: any;
  searchedForService:any
  searchedFor:any

  @Output() search = new EventEmitter();
  @ViewChild("filterRef", { static: false }) filterRef: ElementRef;
  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private streamService: StreamService,
    private homeService: HomeService,
    private dashboardService: DashboardService,
    private circleService: CircleService,
    public chatService: ChatService,
    private circleChatService:CircleChatService,
  ) {
    router.events.subscribe((event) => {
      chatService.createConnectionIfBroken();
      if (event instanceof NavigationStart) {
        this.updateHeaderConfig();

        if (event.url.startsWith("/main/")) {
          this.selectedDropDown = "All";
          // this.userDetail =JSON.parse(localStorage.getItem('userData'));
        } 
        if (event.url.startsWith("/main/tuft-dashboard")) {
          this.showTuftsDropdowm = true;
          // this.userDetail =JSON.parse(localStorage.getItem('userData'));
        }
        if (event.url.startsWith("/main/circles/circle-profile/circle-members")) {
          this.chatPanel = true;
          this.showTuftsDropdowm = false; 
          }
         else {
          this.showTuftsDropdowm = true;
          this.selectedDropDown = "All";
          this.chatPanel = false; 
               }
      }
    });
  }
  subscription: Subscription;
  subscriptionHeader: Subscription;
  headerNavVal: any;
  isCircleHighlight: boolean = false;
  projectDetail: any;
  filterMessage: any;
  headerFilterMessage: any;
  interval: any;
  counter: any;
  tuftsRole = "";
  gotmessageEmit: any;
  gotmessageEmitReply : any;
  ngOnInit() {
    if(window.location.href.includes("/main/circles/circle-profile/circle-members")){
      this.chatPanel = true;
      this.showTuftsDropdowm = false;
    }   
    this.getDepartment();
    this.getDivision();
    this.updateHeaderConfig();
    this.getRecentAct();
    this.interval = setInterval(() => {
      this.getNotif();
      this.getUnreadCountMessage();
    }, 15000);

    this.userDetail = JSON.parse(localStorage.getItem("userData"));
    if (this.userDetail["tuftsRole"].length > 1) {
      this.tuftsRole = "";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "Principal Investigator"
    ) {
      this.tuftsRole = "Principal Investigator Dashboard";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "CTO"
    ) {
      this.tuftsRole = "CTO Dashboard";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "Admin"
    ) {
      this.tuftsRole = "Admin Dashboard";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "CTMS Support"
    ) {
      this.tuftsRole = "CTMS Support Dashboard";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "Research Admin"
    ) {
      this.tuftsRole = "Research Admin Dashboard";
    }
    if (
      this.userDetail["tuftsRole"].length == 1 &&
      this.userDetail["tuftsRole"] == "Study Coordinator"
    ) {
      this.tuftsRole = "Study Coordinator Dashboard";
    }

    this.subscription = this.streamService
      .getFilterSubscription()
      .subscribe((data) => {
        this.filterMessage = data;
        if (this.filterMessage.length <= 0) {
          this.searchField = "";
          this.suggestionList = [];
        }
        if (data == "profile_update") {
          this.userDetail = JSON.parse(localStorage.getItem("userData"));
          this.updateHeaderConfig();
        }
      });
      this.gotmessageEmit = this.chatService
      .getMessageEmit()
      .subscribe((data: any) => {
        let response = data.data;
        if (response) {
        }
      });
    this.gotmessageEmitReply = this.chatService
      .getMessageReplyEmit()
      .subscribe((data: any) => {
        let response = data.data;
        if (response) {
        }
      });

    // this.subscriptionHeader = this.streamService.getHeaderFilterSubscription().subscribe(data => {
    //   this.headerFilterMessage = data;
    // });

    this.projectDetail =
      JSON.parse(localStorage.getItem("full_project")) || "noemail";

    if (this.router.url.startsWith("/main/circles/message/messages-list")) {
      this.isCircleHighlight = true;
    }

    this.chatConfigObs = this.streamService.getChatConfigObs().subscribe(chatConfig => {
      if (this.chatSearchText !== chatConfig.searchTextCopy) this.chatSearchText = chatConfig.searchTextCopy;
    })  
    this.getProjectDetail();
    
  }
  updateHeaderConfig() {
    let projectData = JSON.parse(localStorage.getItem("project_config"));

    let projectConfigList = projectData[0]["configurations"];
    this.projectConfigList = [];
    projectConfigList.forEach((element) => {
      if (
        element["type"] == "HeaderLink" ||
        element["type"] == "Circle" ||
        element["type"] == "Connection" ||
        element["type"] == "Message" ||
        element["type"] == "HeaderLink2" 
      ) {
        this.projectConfigList.push(element);
      }
      if(element["type"] == "settingsEditProfile") {
        this.showEditProfile = element;
      }
      if(element["type"] == "settingsChangePassword") {
        this.showChangePassword = element;
      }
      if(element["type"] == "settingsAdminPanel") {
        this.showAdminPanel = element;
      }
      if(element["type"] == "settingsSignOut") {
        this.showSignOut = element;
      }

      

      if (element["type"] == "SearchBar") {
        this.showSearch = element["isShown"];
      }
    });
  }
  ngOnDestroy() {
    this.searchField = "";
    this.selectedDivision = null;
    this.selectedDepartments = [];
    this.lockBodyScroll(false);
    this.subscription.unsubscribe();
    this.chatConfigObs.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  navigateHeaderMenu(value) {
    if (value["type"] == "HeaderLink") {
      window.open(value["linkUrl"], "_blank");
    }
    if (value["type"] == "HeaderLink2") {
      this.router.navigate([value["linkUrl"]]);
    }
    if (value["type"] == "Circle") {
      this.router.navigate([value["linkUrl"]]);
      this.clearInput();
    }
    if (value["type"] == "Connection") {
      this.router.navigate([value["linkUrl"]]);
      this.clearInput();
    }
    if (value["type"] == "Message") {
      this.getUnreadCountMessage();
      this.router.navigate([value["linkUrl"]]);
      this.clearInput();
    }
    if (value == "HOME") {
      this.projectDetail =
        JSON.parse(localStorage.getItem("full_project")) || "noemail";
      if (this.userDetail["tuftsRole"].length > 1) {
        this.router.navigate([this.projectDetail["homepageNavigationLink"]]);
      } else {
        this.router.navigate(["main/tuft-dashboard"]);
      }
    }
  }
  getUnreadCountMessage() {
    this.dashboardService.getUnreadMessageCount().subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.messageCount = res.data.unreadChats;
        }
      },
      (err) => {}
    );
  }
  notifcationdata: any;
  countForNotification: any;
  showNotifyBell:any
  getNotif() {
    this.circleService.getNotification().subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.notifcationdata = res.data.isSeenData;
          this.showNotifyBell = this.notifcationdata.isMentionedChatRead
          this.countForNotification = this.notifcationdata.unreadMentionChatReplies + this.notifcationdata.unreadMentionedChats
        }
      },
      (err) => {}
    );
  }

  selectedDropDown: any = "All";
  getDropDownVal(selectedDrop) {
    this.suggestionList = [];
    this.searchField = "";
    this.selectedDropDown = selectedDrop;
  }

  filterFunction(){
    this.streamService.streamFilterMessage(this.searchField);
    this.suggestionList = [];
    if(this.router.url.startsWith('/main/setting')){
      this.streamService.streamFilterMessage(this.searchField);
      return
    }
  
    if(this.selectedDropDown == 'All') {
      if(this.router.url.startsWith('/main/circles/search-all/all-members-search')) {
  
      } else {
        this.router.navigate(["/main/circles/search-all/all-members-search"])
      }
  
    }
    if(this.selectedDropDown == 'Circles') {
      this.router.navigate(["/main/circles/search-circle"])
      this.selectedDropDown = "Circles"
  
    }if(this.selectedDropDown == 'Members') {
      this.router.navigate(["/main/circles/search-user"])
      this.selectedDropDown = "Members"
    }
    // localStorage.setItem('filterValue',this.searchField);
  }

  clearInput() {
    this.searchField = "";
    this.suggestionList = [];
  }

  Ontextenter() {
    if (this.router.url.startsWith("/main/setting")) {
      return null;
    }

    this.suggestionList = [];
    if (this.searchField == "") {
      this.suggestionList = [];
      return;
    }
    // if(this.selectedDropDown == 'All') {
    //   let query ="text="+this.searchField
    //   this.homeService.getSuggestionCircle(query).subscribe((res) => {
    //      if(res['message'] =='Success') {
    //       this.suggestionList = res.data.circleList;
    //      }
    //    }, err => {

    //    });
    // }
    if (this.selectedDropDown == "Circles") {
      let query = "text=" + this.searchField;
      this.homeService.getSuggestionCircle(query).subscribe(
        (res) => {
          if (res["message"] == "Success") {
            this.suggestionList = res.data.circleList;
          }
        },
        (err) => {}
      );
    }

    if (this.selectedDropDown == "Members") {
      let query = "text=" + this.searchField.trim();
      this.homeService.getSuggestionMember(query).subscribe(
        (res) => {
          if (res["message"] == "Success") {
            this.suggestionList = res.data.userList;
          }
        },
        (err) => {}
      );
    }
  }

  logoutUser() {
    this.commonService.logOut();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  // DIVISION / DEPARTMENT FILTER

  getDepartment() {
    this.dashboardService.getDepartmentAPI("").subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.departmentList = res.data.departments;
        } else {
          this.departmentList = [];
        }
      },
      (err) => {}
    );
  }

  getDivision() {
    this.dashboardService.getDivisionAPI().subscribe(
      (res) => {
        if (res["message"] == "Success" && res.data && res.data.divisions) {
          this.divisionList = res.data.divisions;
        } else {
          this.divisionList = [];
        }
      },
      (err) => {}
    );
  }

  get allDepartmentNames(): string[] {
    return this.departmentList.map((element) => element["department"]);
  }

  // departments of a division, or every department when no division is picked
  getDepartmentsFor(division: string): string[] {
    if (!division) {
      return this.allDepartmentNames;
    }
    let found = this.divisionList.find((item) => item["division"] == division);
    return found ? found["departments"] || [] : [];
  }

  get filteredDraftDepartments(): string[] {
    let search = this.departmentSearchText.trim().toLowerCase();
    let departments = this.getDepartmentsFor(this.draftDivision);
    return search ? departments.filter((dept) => dept.toLowerCase().includes(search)) : departments;
  }

  get filterDivisionLabel(): string {
    return this.selectedDivision || "All divisions";
  }

  get filterDepartmentLabel(): string {
    if (this.selectedDepartments.length == 0) {
      return "All departments";
    }
    if (this.selectedDepartments.length == 1) {
      return this.selectedDepartments[0];
    }
    return this.selectedDepartments.length + " departments";
  }

  get hasActiveFilter(): boolean {
    return !!this.selectedDivision || this.selectedDepartments.length > 0;
  }

  toggleFilterPanel() {
    if (this.showFilterPanel) {
      this.closeFilterPanel();
      return;
    }
    this.draftDivision = this.selectedDivision;
    this.draftDepartments = [...this.selectedDepartments];
    this.departmentSearchText = "";
    this.showFilterPanel = true;
    this.lockBodyScroll(true);
  }

  // closing without applying discards the draft
  closeFilterPanel() {
    this.showFilterPanel = false;
    this.lockBodyScroll(false);
  }

  // on small screens the panel is a bottom sheet, keep the page behind it still
  lockBodyScroll(lock: boolean) {
    document.body.style.overflow = lock && window.innerWidth < 768 ? "hidden" : "";
  }

  selectDraftDivision(division: string) {
    if (this.draftDivision == division) {
      return;
    }
    this.draftDivision = division;
    this.draftDepartments = [];
    this.departmentSearchText = "";
  }

  isDraftDepartmentSelected(department: string): boolean {
    return this.draftDepartments.indexOf(department) > -1;
  }

  toggleDraftDepartment(department: string) {
    if (this.isDraftDepartmentSelected(department)) {
      this.draftDepartments = this.draftDepartments.filter((dept) => dept != department);
    } else {
      this.draftDepartments = [...this.draftDepartments, department];
    }
  }

  selectAllDraftDepartments() {
    this.draftDepartments = [];
  }

  clearFilter() {
    this.draftDivision = null;
    this.draftDepartments = [];
    this.departmentSearchText = "";
  }

  applyFilter() {
    this.selectedDivision = this.draftDivision;
    this.selectedDepartments = [...this.draftDepartments];
    this.closeFilterPanel();
    this.emitFilterValue();
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (this.showFilterPanel && this.filterRef && !this.filterRef.nativeElement.contains(event.target)) {
      this.closeFilterPanel();
    }
  }

  @HostListener("document:keydown.escape")
  onEscape() {
    if (this.showFilterPanel) {
      this.closeFilterPanel();
    }
  }

  // reset the filter state when leaving the dashboard from the profile menu
  onSelectAllRole() {
    this.selectedDivision = null;
    this.selectedDepartments = [];
    this.closeFilterPanel();
  }

  emitFilterValue() {
    let tempDept = [...this.selectedDepartments];
    // only a division picked: filter by every department in that division
    if (tempDept.length == 0 && this.selectedDivision) {
      tempDept = this.getDepartmentsFor(this.selectedDivision);
    }
    this.streamService.streamHeaderFilterMessage(tempDept);
  }

  
checkedMention(value){
  let replyMention = value.isReply
  let replyMentions = ""
  if(replyMention == true){
    replyMentions = "replyMention"
  }
  else{
    replyMentions = "chatMention"
  }
  let req = {
    chatId: value.chatId,
    type: replyMentions
}
this.homeService.putNotifyRead(req).subscribe(
  (res) => {
    if ((res["message"] = "Success")) {
      this.getMentionss()
    } else {
    }
  },
  (err) => {
  }
);
}
checkedRecent(value){
  let request = {
    circleId: value.circleId,
    type: "activity"
}
this.homeService.putNotifyRead(request).subscribe(
  (res) => {
    if ((res["message"] = "Success")) {
      this.getRecentAct()
    } else {
      console.log('wait')
    }
  },
  (err) => {
  }
);
}

mentionsNot:any
totalmentions = 0
mentionMessages:any
newMesg = []
totalnotifications:any
getMentionss() {
  let query = "limit=10&offset=0"
  this.homeService.getMentionNotify(query).subscribe(
    (res) => {
      if (res["message"] == "Success") {
        this.mentionsNot = res.data.chatList;
        this.totalmentions = res.data.totalCount;
        this.totalnotifications = this.totalmentions + this.totalRecentAct
      this.mentionsNot.forEach(element => {
        if(element['taggedUsers']){
          element['message'] = this.checkTaggedMessages(element);
        }
      });
      }
    },
    (err) => {}
  );
}

checkTaggedMessages(response) {
  let message = response.message;
  let list1 = response.taggedUsers;
  let list2 = response.taggedStudies;
  let list3 = response.taggedPatients;
  for (let i = 0; i < message.length; i++) {
    for (let j = 0; j < list1.length; j++) {
      const regex = "[[" + list1[j]["userId"] + "]]";
      message = message.replaceAll(
        regex,
          "@" +
          list1[j]["fullName"]
      );
    }
    for (let k = 0; k < list2.length; k++) {
      const regex = "[[" + list2[k]["studyId"] + "]]";
      message = message.replaceAll(
        regex,
          "#StudyID: " +
          list2[k]["studyNumber"]
      );
    }
    for (let l = 0; l < list3.length; l++) {
      const regex = "[[" + list3[l]["patientId"] + "]]";
      message = message.replaceAll(
        regex,
          "#PatientID: " +
          list3[l]["patientIdentifier"]
      );
    }
  }
  return message;
}

recentAct:any
totalRecentAct = 0
getRecentAct() {
  let query = "limit=10&offset=0"
  this.homeService.getRecentActivity(query).subscribe(
    (res) => {
      if (res["message"] == "Success") {
        this.recentAct = res.data.activities;
        this.totalRecentAct = res.data.totalCount;
      }
    this.getMentionss();
    },
    (err) => {}
  );
}
searchedd:string
  searchClicked() {
    console.log('workings')
    // this.searchedd = searchData
    this.streamService.setChatConfigObs({ searchData: { isModalOpen: true } });
    // this.searchedForService = this.streamService.getChatConfigObs().subscribe(chatConfig => {
    //   this.searchedFor = chatConfig.searchTextCopy
    // });
  }
  userData:any
  getProjectDetail() {
    let detail = localStorage.getItem('userData')
     // this.userData = JSON.parse(localStorage.getItem("userData"));
     if(detail == 'undefined') {
       this.userData = ''
     } else {
       this.userData = JSON.parse(detail);
     }

     var principalColor = "#5C0606"
     var coordinatorColor = "#1ba1e2"
     var researchAdminColor = "#836200"
     var admincolor = "#880ED4"
     // for use in chatting window
     var principalColorFade = "#5C06061f"
     var coordinatorColorFade = "#1ba1e21f"
     var researchAdminColorFade = "#8362001f"
     var admincolorFade = "#880ED41f"
     // for use in chatting window -- icons
     var principalColorIcon = "#5C06069f"
     var coordinatorColorIcon = "#20a1df"
     var researchAdminColorIcon = "#8362009f"
     var admincolorIcon = "#880ED49f"
     // for bell icon
     var principalColorBell = "#d86161"
     var coordinatorColorBell = "#1ba1e29f"
     var researchAdminColorBell = "#b99d4a"
     var admincolorBell = "#c05aff"

     if(!this.userData) {
      document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
      document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
      document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
      document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
    }
    if( this.userData !== null && this.userData['tuftsRole'].length > 1) {
      document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
      document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
      document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
      document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
    }
    if( this.userData !== null && this.userData['tuftsRole'].length == 1 && (this.userData['tuftsRole'][0] == 'CTO' || this.userData['tuftsRole'][0] == 'Admin' || this.userData['tuftsRole'][0] == 'CTMS Support')) {
      document.documentElement.style.setProperty('--theme_secondary',admincolor);
      document.documentElement.style.setProperty('--theme_fade',admincolorFade);
      document.documentElement.style.setProperty('--theme_icon',admincolorIcon);
      document.documentElement.style.setProperty('--theme_bell',admincolorBell);
    }
    if( this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Principal Investigator') {
      document.documentElement.style.setProperty('--theme_secondary',principalColor);
      document.documentElement.style.setProperty('--theme_fade',principalColorFade);
      document.documentElement.style.setProperty('--theme_icon',principalColorIcon);
      document.documentElement.style.setProperty('--theme_bell',principalColorBell);
    }
    
    if(this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Study Coordinator') {
      document.documentElement.style.setProperty('--theme_secondary',coordinatorColor);
      document.documentElement.style.setProperty('--theme_fade',coordinatorColorFade);
      document.documentElement.style.setProperty('--theme_icon',coordinatorColorIcon);
      document.documentElement.style.setProperty('--theme_bell',coordinatorColorBell);
    }
    
    if(this.userData !== null && this.userData['tuftsRole'].length == 1 && this.userData['tuftsRole'][0] == 'Research Admin') {
      document.documentElement.style.setProperty('--theme_secondary',researchAdminColor);
      document.documentElement.style.setProperty('--theme_fade',researchAdminColorFade);
      document.documentElement.style.setProperty('--theme_icon',researchAdminColorIcon);
      document.documentElement.style.setProperty('--theme_bell',researchAdminColorBell);
    }
    
   }

}